module.exports = __webpack_public_path__ + "img/coming-soon-dark.da4040a1.svg";